import React from 'react';
import Typography from '@material-ui/core/Typography';


export default function Battery(props){
  if(props.level!=undefined){
    return(<img style={{height:'100%'}} src={'/images/battery/battery_'+props.level+'.png'}/>)
  }
}
